import * as Request from '../../request'
import * as Constants from './constants'

export const fetchPools = () =>
Request.requestActionCreator(Constants.FETCH_POOLS)({
  method: 'GET',
  url: `${Constants.SERVER_RESOURCE}/ips`,
})

export const switchPools = (communityIdentifier: string, pool: string) =>
Request.requestActionCreator(Constants.POOL_CONFIG)({
  method: 'PUT',
  url: `/ippools/${communityIdentifier}/config/${pool}`,
})

export const fetchCommunities = () =>
Request.requestActionCreator(Constants.POOLS_FETCH_COMMUNITIES)({
  method: 'GET',
  url: `${Constants.SERVER_RESOURCE}/communities`,
})



// WEBPACK FOOTER //
// ./src/pages/ip-pools/actions.ts